var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.switchClasss,
      style: _vm.switchStyle,
      on: { click: _vm.handleClick }
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.switchValue,
              expression: "switchValue"
            }
          ],
          staticClass: "mku-switch__inner-before"
        },
        [_vm._t("open")],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          class: [
            "mku-switch__icon",
            { "mku-switch__icon--loading": _vm.loading }
          ]
        },
        [_c("i", { style: _vm.iconLoadingStyle })]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.switchValue,
              expression: "!switchValue"
            }
          ],
          staticClass: "mku-switch__inner-after"
        },
        [_vm._t("close")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }